<template>
  <b-row>
    <b-col sm="12">
      <b-card body-class="py-2">
        <section class="list-view-heading">
          <ModuleViewHeading
            :module-id="access.module_id"
            :profile-id="access.profile_id"
            :reference="access.view_reference"
            summary-only
          />
          <div class="list-view-heading__controls">
            <div class="list-view-heading__actions">
              <TabHeaderActions />
            </div>
          </div>
        </section>
      </b-card>

      <b-row>
        <b-col sm="6">
          <b-card>
            <b-badge variant="dark" v-if="this.projectSelected.customer">
              {{this.projectSelected.customer.name}}
            </b-badge>
            {{this.projectSelected.name}}

            <FullCalendar defaultView="dayGridMonth"
                          class="detail-hours-calendar"
                          :plugins="calendarPlugins"
                          :locale="calendarOptions.locale"
                          :weekends="true"
                          :events="calendarOptions.event"
                          :selectable="true"
                          :titleFormat="calendarTitleFormat"
                          @eventClick="onCalendarEventClick"
                          @dateClick="dateClick "/>
            <div class="detail-hours-status-legend detail-hours-status-legend--calendar">
              <span class="detail-hours-status-legend__item"><i class="detail-hours-status-legend__dot detail-hours-status-legend__dot--not-invoice"></i>No facturable</span>
              <span class="detail-hours-status-legend__item"><i class="detail-hours-status-legend__dot detail-hours-status-legend__dot--unbilled"></i>Sin facturar</span>
              <span class="detail-hours-status-legend__item"><i class="detail-hours-status-legend__dot detail-hours-status-legend__dot--to-invoice"></i>Por facturar</span>
              <span class="detail-hours-status-legend__item"><i class="detail-hours-status-legend__dot detail-hours-status-legend__dot--invoiced"></i>Facturada</span>
            </div>
          </b-card>
        </b-col>
        <b-col sm="6">
          <b-card>
            <b-row class="mb-3">
              <b-col md="6">

                <b-badge variant="dark" v-if="this.projectSelected.customer">
                  {{this.projectSelected.customer.name}}
                </b-badge>
                {{this.projectSelected.name}}

                <h2>{{moment(this.dateSelected).format('DD')}} de
                    {{moment(this.dateSelected).format('MMMM')}} de
                    {{moment(this.dateSelected).format('YYYY')}}</h2>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <div class="detail-hours-status-legend detail-hours-status-legend--table">
                  <span class="detail-hours-status-legend__item"><i class="detail-hours-status-legend__dot detail-hours-status-legend__dot--not-invoice"></i>No facturable</span>
                  <span class="detail-hours-status-legend__item"><i class="detail-hours-status-legend__dot detail-hours-status-legend__dot--unbilled"></i>Sin facturar</span>
                  <span class="detail-hours-status-legend__item"><i class="detail-hours-status-legend__dot detail-hours-status-legend__dot--to-invoice"></i>Por facturar</span>
                  <span class="detail-hours-status-legend__item"><i class="detail-hours-status-legend__dot detail-hours-status-legend__dot--invoiced"></i>Facturada</span>
                </div>
                <b-table class="mb-0 app-table app-table--compact detail-hours-table"
                        responsive="sm"
                        :stacked="isMobileViewport ? 'md' : false"
                        :hover="true"
                        :small="true"
                        :fixed="false"
                        :items="table.items"
                        :fields="table.fields"
                        :tbody-tr-class="rowClass"
                        @row-clicked="onTableRowClicked"
                        v-if="table.items.length">

                    <template v-slot:table-colgroup="scope">
                      <col
                        v-for="field in scope.fields"
                        :key="field.key"
                        :style="{ width: isMobileViewport ? 'auto' : field.width }"
                      >
                    </template>

                    <template v-slot:cell(employee_id)="data">
                      <b>{{ data.item.employee.id }} - {{ data.item.employee.name }}</b>
                    </template>

                    <template v-slot:cell(description)="data">
                      <div>
                        {{ data.item.description }}
                        <small v-if="data.item.task_id" class="detail-hours-task-source"><AppIcon name="tasks" /> Desde tarea{{ data.item.task ? ': ' + data.item.task.title : '' }}</small>
                      </div>
                    </template>

                    <template v-slot:cell(hours)="data">
                      <b>{{ data.item.hours }} hs</b>
                    </template>

                    <template v-slot:cell(f_action)="data">
                      <b-dropdown right
                                  no-caret
                                  size="sm"
                                  variant="link"
                                  boundary="window"
                                  :toggle-class="isMobileViewport ? 'detail-hours-action-toggle-labeled' : 'app-table-action-toggle'"
                                  v-if="!data.item.sale_id">
                        <template #button-content>
                          <AppIcon name="more_vert" :label="isMobileViewport ? 'Opciones' : 'Acciones'" :class="{ 'mr-1': isMobileViewport }" />
                          <span v-if="isMobileViewport">Opciones</span>
                        </template>
                        <b-dropdown-header v-if="!data.item.sale_id && !data.item.not_invoice">Facturar</b-dropdown-header>
                        <b-dropdown-item @click="checkForInvoice(data.item, 'check')" v-if="!data.item.sale_id && !data.item.not_invoice && !data.item.check_for_invoice">
                          <AppIcon name="event_available" class="detail-hours-dropdown-icon detail-hours-dropdown-icon--to-invoice" /> Marcar para facturar
                        </b-dropdown-item>
                        <b-dropdown-item @click="checkForInvoice(data.item, 'uncheck')" v-if="!data.item.sale_id && !data.item.not_invoice && data.item.check_for_invoice">
                          <AppIcon name="event_busy" class="detail-hours-dropdown-icon detail-hours-dropdown-icon--unbilled" /> Desmarcar para facturar
                        </b-dropdown-item>
                        <b-dropdown-header v-if="!data.item.sale_id && !data.item.check_for_invoice">Sin Factura</b-dropdown-header>
                        <b-dropdown-item @click="checkNotInvoice(data.item, 'check')" v-if="!data.item.sale_id && !data.item.check_for_invoice && !data.item.not_invoice">
                          <AppIcon name="archive" class="detail-hours-dropdown-icon detail-hours-dropdown-icon--not-invoice" /> No facturar
                        </b-dropdown-item>
                        <b-dropdown-item @click="checkNotInvoice(data.item, 'uncheck')" v-if="!data.item.sale_id && !data.item.check_for_invoice && data.item.not_invoice">
                          <AppIcon name="undo" class="detail-hours-dropdown-icon detail-hours-dropdown-icon--unbilled" /> Deshacer
                        </b-dropdown-item>
                      </b-dropdown>
                    </template>

                </b-table>
                <EmptyState v-else
                            icon="history"
                            title="No se encontraron registros"
                            description="No hay horas cargadas para el día seleccionado." />
              </b-col>
            </b-row>
            <b-row class="mt-3" v-if="table.items.length">
              <b-col md="12">
                <div class="detail-hours-totals">
                  <span class="detail-hours-totals__label">Total de hs en el día</span>
                  <span class="detail-hours-totals__value">{{this.totalProjects.toFixed(2)}} Hs</span>
                </div>
              </b-col>
            </b-row>
          </b-card>

          <b-card v-if="forInvoice>0">
            <h5 class="mb-3"><AppIcon name="receipt_long" class="mr-1" />Horas pendientes de facturación</h5>

            <div class="pending-invoice-info" v-if="projectSelected.monthly_hours_included > 0">
              <AppIcon name="info" class="pending-invoice-info__icon" />
              <span>El cliente tiene <b>{{projectSelected.monthly_hours_included}} {{projectSelected.monthly_hours_included == 1 ? 'Hora' : 'Horas'}}</b> dentro del mes</span>
            </div>

            <div class="pending-invoice-note" v-if="projectSelected.observations">
              <AppIcon name="sticky_note_2" class="pending-invoice-note__icon" />
              <span>{{projectSelected.observations}}</span>
            </div>

            <div class="pending-invoice-stat">
              <div>
                <span class="pending-invoice-stat__label">Total pendiente de facturar</span>
                <span class="pending-invoice-stat__value">{{ forInvoice }} Horas</span>
              </div>
              <div class="pending-invoice-stat__actions">
                <b-button type="button" variant="outline-dark" @click="invoiceHoursManual()">
                  <AppIcon name="fact_check" class="mr-1" />Marcar como facturado
                </b-button>
                <b-button type="button" variant="dark" @click="invoiceHours()">
                  <AppIcon name="receipt_long" class="mr-1" />Facturar
                </b-button>
              </div>
            </div>
          </b-card>

          <b-card>
            <h5 class="mb-3">
              Resultado {{moment(this.dateSelected).format('MMMM')}} - {{moment(this.dateSelected).format('YYYY')}}
            </h5>

            <div class="app-modal-detail-list">
              <div class="app-modal-detail-list__row">
                <span class="app-modal-detail-list__label">No facturables</span>
                <span class="app-modal-detail-list__value">{{ getDetailHoursMonths()['no_facturables'] }} / {{ this.projectSelected.monthly_hours_included }} hs</span>
              </div>
              <div class="app-modal-detail-list__row">
                <span class="app-modal-detail-list__label">Sin facturar</span>
                <span class="app-modal-detail-list__value text-danger"><b>{{ getDetailHoursMonths()['sin_facturar'] }} hs</b></span>
              </div>
              <div class="app-modal-detail-list__row">
                <span class="app-modal-detail-list__label">Por facturar</span>
                <span class="app-modal-detail-list__value text-warning"><b>{{ getDetailHoursMonths()['por_facturar'] }} hs</b></span>
              </div>
              <div class="app-modal-detail-list__row">
                <span class="app-modal-detail-list__label">Facturadas</span>
                <span class="app-modal-detail-list__value text-success"><b>{{ getDetailHoursMonths()['facturadas'] }} hs</b></span>
              </div>
            </div>
          </b-card>

        </b-col>
      </b-row>

      <b-card body-class="py-2">
        <div class="list-view-footer">
          <b-button type="button" variant="outline-dark" size="sm" @click="goProjects()">
            <AppIcon name="back" />
            Volver
          </b-button>
        </div>
      </b-card>
    </b-col>
  </b-row>
</template>
<script>
  import serviceAPI from './services'
  import Profiles from '@/config/profiles'
  import Error from '@/handler/error'
  import ErrorToken from '@/handler/errorToken'
  import Modules from '@/config/modules'
  import Helper from '@/handler/helper'
  import Theme from '@/config/theme'
  import moment from 'moment'
  import {EventBus} from '@/handler/event-bus'
  import TabHeaderActions from '@/components/inc/tabs/TabHeaderActions'

  import FullCalendar from '@fullcalendar/vue'
  import dayGridPlugin from '@fullcalendar/daygrid'
  import esLocale from '@fullcalendar/core/locales/es';
  import interactionPlugin from '@fullcalendar/interaction';


  export default {
    components: {
      FullCalendar,
      TabHeaderActions
    },
    data: () => {
      return {
        access: {
          module_id: Modules.PROYECTOS,
          profile_id: Profiles.PERSONAL,
          view_reference: 'detailHoursProjects',
          elements: {}
        },
        calendarPlugins: [ dayGridPlugin, interactionPlugin ],
        calendarOptions: {
          locale: esLocale,
          event: []
        },
        table : {
          items: [],
          fields: [],
        },
        isMobileViewport: false,
        dateSelected: moment(),
        selectedHourId: null,
        projectSelectedID: 0,
        projectSelected: {},
        forInvoice: 0,
        arr: {
          detailsHours: []
        },
        routerFrom: '',
      }
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.routerFrom = from.name;
      });
    },
    created () {
      /* Configurar permisos de vistas y elementos */
      Helper.hasAccessView(this.access)
      /* Fin configuracion */
    },
    mounted () {
      this.projectSelectedID = this.$route.params.projectID

      this.mobileMql = window.matchMedia('(max-width: 767.98px)')
      this.isMobileViewport = this.mobileMql.matches
      this.mobileMql.addEventListener('change', this.updateMobileViewport)
      this.loadFieldTable()

      moment.locale('es');
      this.load()
      this.getHoursForInvoice()

      this._start = true
    },
    beforeDestroy() {
      if(this.mobileMql) {
        this.mobileMql.removeEventListener('change', this.updateMobileViewport)
      }
    },
    activated() {
      if(this._start) {
        this._start = false
        return false
      }

      this.load()
      this.getHoursForInvoice()
    },
    watch: {
      // Si el viewport cruza el breakpoint mobile (resize/rotación), las
      // clases de alineación y el label del kebab tienen que recalcularse.
      isMobileViewport() {
        this.loadFieldTable()
      },
    },
    computed: {
      totalProjects: function() {
        var total = 0
        this.table.items.forEach(element => {
          if(element.projects_id) {
            total = total + parseFloat(element.hours)
          }
        })
        return total
      },
      isEmployee(){
        if(Helper.getEmployee()) {
          if(Helper.getEmployee().permission_admin_projects) {
            return false
          } else {
            return true
          }
        } else {
          return false
        }
      },
    },
    methods: {
      // El titleFormat automático del locale es.js arma "enero de 2026" (el
      // "de" es gramática española correcta para esa combinación, no un
      // error del locale) -- queremos solo "Enero 2026", así que se arma a
      // mano en vez de dejarle el formateo por defecto a FullCalendar.
      //
      // moment.utc(), NO moment(): arg.date.marker está en el dominio UTC
      // (medianoche UTC = 1° del mes) sin importar el timezone real; leerlo
      // con moment() local lo corre un mes atrás en husos negativos (ej.
      // Argentina UTC-3: "Julio" en vez de "Agosto").
      calendarTitleFormat(arg) {
        var text = moment.utc(arg.date.marker).format('MMMM YYYY')
        return text.charAt(0).toUpperCase() + text.slice(1)
      },
      // RESPONSIVE
      updateMobileViewport(e) {
        this.isMobileViewport = e.matches
      },
      alignClass(desktopClass) {
        return this.isMobileViewport ? 'text-left' : desktopClass
      },
      loadFieldTable() {
        this.table.fields = []
        this.table.fields.push({key: 'employee_id', label: 'Empleado', class:"align-middle " + this.alignClass('text-left'), width:"25%"})
        // .text-wrap (Bootstrap, !important) pisa el nowrap+ellipsis global
        // de .app-table td — una descripción larga necesita pasar a un
        // segundo renglón en vez de cortarse y correr a Horas/Acciones
        // fuera de la vista.
        this.table.fields.push({key: 'description', label: 'Detalle', class:"align-middle text-wrap " + this.alignClass('text-left'), width:"55%"})
        this.table.fields.push({key: 'hours', label: 'Horas', class:"align-middle " + this.alignClass('text-center'), width:"15%"})
        // Sin drawer que aloje las acciones en mobile, el kebab se
        // conserva ahí también, con label y texto "Opciones" visibles.
        this.table.fields.push({key: 'f_action', label: this.isMobileViewport ? 'Acción' : '', class:"align-middle " + this.alignClass('text-right'), width:"5%"})
      },
      setMetaTitle(title) {
        EventBus.$emit('Update:TabTitle', 'Proyecto: ' + title)
      },
      validation() {
        var employee = Helper.getEmployee()
        if(employee && !employee.permission_admin_projects) {
          if(this.projectSelected.employee_id != employee.id) {
            this.$router.push({ name: 'Error403' })
          }
        }
      },
      dateClick(date) {
        this.dateSelected = date.dateStr
        this.selectedHourId = null
        this.getHours()
      },
      onCalendarEventClick(info) {
        // El calendario agrupa horas por día: al pulsar un evento sólo se
        // navega a ese día para ver su detalle completo en la tabla.
        this.dateSelected = info.event.startStr
        this.selectedHourId = null
        this.getHours()
      },
      load(){
        this.loadCalendar()
        this.getHours()
        this.loadProjectSelected()
      },
      loadCalendar() {
        let loader = this.$loading.show();

        this.calendarOptions.event = []

        var data = {
          project_id: this.projectSelectedID
        }
        var result = serviceAPI.obtenerHorasByProject(data)

        result.then((response) => {
          var data = response.data
          this.arr.detailsHours = data.projects

          data.projects.forEach(element => {
            var event = {}

            let title = ''
            let color = ''

            // Variantes "-hover" (más oscuras) en vez de los tokens base:
            // FullCalendar pinta el título del evento en blanco por default,
            // y contra el tono base (pensado para texto propio, no como
            // fondo sólido) el contraste quedaba pobre — con estas se
            // garantiza texto blanco legible sobre cualquiera de los 4.
            if(!element.sale_id && !element.check_for_invoice && element.not_invoice) {
              title = 'No Facturable: ' + element.hours + ' hs'
              color = Theme.getColor(Theme.TOKENS.text, '#1e2d3d')
            }

            if(!element.sale_id && !element.check_for_invoice && !element.not_invoice) {
              title = 'Sin Facturar: ' + element.hours + ' hs'
              color = Theme.getColor(Theme.TOKENS.dangerHover, '#a82f3d')
            }

            if(!element.sale_id && element.check_for_invoice && !element.not_invoice) {
              title = 'Por Facturar: ' + element.hours + ' hs'
              color = Theme.getColor(Theme.TOKENS.warningHover, '#854c00')
            }

            if(element.sale_id && element.check_for_invoice && !element.not_invoice) {
              title = 'Facturadas: ' + element.hours + ' hs'
              color = Theme.getColor(Theme.TOKENS.successHover, '#185f3f')
            }

            event = {
              id: String(element.id),
              title: title,
              start: element.date,
              // Los eventos de día completo usan end exclusivo en FullCalendar.
              allDay: true,
              end: moment(element.date).add(1, 'day').format('YYYY-MM-DD'),
              color: color,
              textColor: '#ffffff',
            }
            this.calendarOptions.event.push(event)
          });

          loader.hide()
        })
        .catch(error => {
          loader.hide()
          this.$awn.alert(Error.showError(error))
        });
      },
      getHours(selectedHourId = null) {
        let loader = this.$loading.show();
        var data = {
          project_id: this.projectSelectedID,
          date: this.dateSelected
        }
        var result = serviceAPI.obtenerHorasByDiaByProyecto(data)

        result.then((response) => {
          var data = response.data

          this.table.items = data
          this.selectedHourId = selectedHourId && data.some(item => item.id == selectedHourId)
            ? selectedHourId
            : null

          loader.hide()
        })
        .catch(error => {
          loader.hide()
          this.$awn.alert(Error.showError(error))
        });
      },
      hourStatusKey(item) {
        if (item.not_invoice) return 'not-invoice'
        if (item.sale_id) return 'invoiced'
        if (item.check_for_invoice) return 'to-invoice'
        return 'unbilled'
      },
      rowClass(item, type) {
        if (type !== 'row' || !item) return ''
        var classes = ['detail-hours-row--' + this.hourStatusKey(item)]
        if (!this.isMobileViewport && this.selectedHourId && item.id == this.selectedHourId) classes.push('detail-hours-row--active')
        return classes.join(' ')
      },
      onTableRowClicked(item, index, event) {
        if (!item) return
        if (event && event.target && event.target.closest('.dropdown')) return
        this.selectedHourId = item.id
      },
      loadProjectSelected(){
        let loader = this.$loading.show();
        var result = serviceAPI.mostrarProyectos(this.projectSelectedID)

        result.then((response) => {
          var data = response.data
          this.projectSelected = data

          // VALIDACION DE VISUALIZACION
          this.validation()
          // FIN VALIDACION

          this.setMetaTitle(this.projectSelected.name)

          loader.hide()
        })
        .catch(error => {
          loader.hide()
          this.$awn.alert(ErrorToken.valid(error));
        })
      },

      getHoursForInvoice() {
        var result = serviceAPI.obtenerHoursForInvoice({
          projects_id: this.projectSelectedID
        })

        result.then((response) => {
          var data = response.data
          this.forInvoice = parseFloat(data)
        })
      },
      checkForInvoice(item, operation='check') {
        let loader = this.$loading.show();

        var result = serviceAPI.guardarCheckForInvoice({
          id: item.id
        });

        result.then((response) => {
          loader.hide()

          this.loadCalendar()
          this.getHours()
          this.getHoursForInvoice()

          let msj = ''
          if(operation=='check') {
            msj = item.hours + " Horas agregadas para facturar"
          }
          if(operation=='uncheck') {
            msj = item.hours + " Horas quitadas para facturar"
          }

          this.$awn.success("Datos guardados con éxito. " + msj);
        })
        .catch(error => {
          loader.hide()
          this.$awn.alert(Error.showError(error));
        })
      },
      // Confirm estándar: header con ícono + tinte suave
      // (.app-confirm-header) en vez de header-bg-variant sólido, size
      // 'sm' siempre, y okVariant/headerClass según sea o no destructiva.
      confirmDialog(message, options) {
        var danger = !!options.danger
        var icon = options.icon || (danger ? 'warning' : 'help')
        var title = this.$createElement('span', { class: 'app-confirm-header__title' }, [
          this.$createElement('AppIcon', { props: { name: icon } }),
          options.title
        ])
        return this.$bvModal.msgBoxConfirm(message, {
          title: title,
          size: 'sm',
          buttonSize: 'sm',
          okVariant: danger ? 'danger' : 'dark',
          okTitle: options.okTitle,
          cancelTitle: options.cancelTitle || 'Cancelar',
          footerClass: 'p-2',
          headerClass: danger ? 'app-confirm-header app-confirm-header--danger' : 'app-confirm-header',
          hideHeaderClose: false,
          centered: true
        })
      },
      invoiceHours() {
        if(!this.projectSelected.service_invoice) {
          this.$awn.alert("Falta configurar en el proyecto, el servicio vinculado a la facturación.");
          return false
        }

        var list_default = this.projectSelected.customer.price_list.price_list_id

        var price_default = 0
        this.projectSelected.service_invoice.prices.forEach(element => {
          if(element.price_list_id == list_default) {
            price_default = parseFloat(element.amount_total)
          }
        });

        this.$router.push({
          name: 'SalesStaffSalesGenerateByProjects',
          params: {
            projectsID: this.projectSelected.id
          },
          query: {
            customers_id: this.projectSelected.customer_id,
            customers: JSON.stringify(this.projectSelected.customer),
            detail: JSON.stringify([
              {
                quantity: this.forInvoice,
                service: this.projectSelected.service_invoice,
                services: this.projectSelected.service_invoice,
                currency: this.projectSelected.customer.price_list.list.currency.code,
                price: price_default,
                description: this.projectSelected.service_invoice.display_sales_detail,
                price_list: this.projectSelected.customer.price_list.list,
              }
            ])
          }
        })
      },
      invoiceHoursManual() {
        this.confirmDialog('¿Se marcarán como facturadas las [' + this.forInvoice + ' horas] del proyecto [' + this.projectSelected.name + ']. ¿Desea continuar?', {
          title: 'Marcar como facturado',
          icon: 'receipt_long',
          okTitle: 'MARCAR',
          cancelTitle: 'NO'
        })
        .then(value => {
          if (value) {
            let loader = this.$loading.show();

            var result = serviceAPI.guardarCheckInvoiceManual({
              projects_id: this.projectSelectedID
            });

            result.then(() => {
              loader.hide()

              this.loadCalendar()
              this.getHours()
              this.getHoursForInvoice()

              this.$awn.success("Datos guardados con éxito.");
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })
          }
        })
      },

      checkNotInvoice(item, operation='check') {
        let loader = this.$loading.show();

        var result = serviceAPI.guardarCheckNotInvoice({
          id: item.id
        });

        result.then((response) => {
          loader.hide()

          this.loadCalendar()
          this.getHours()
          this.getHoursForInvoice()

          let msj = ''
          if(operation=='check') {
            msj = item.hours + " Horas no facturable"
          }
          if(operation=='uncheck') {
            msj = item.hours + " Horas reestablecidas para facturar"
          }

          this.$awn.success("Datos guardados con éxito. " + msj);
        })
        .catch(error => {
          loader.hide()
          this.$awn.alert(Error.showError(error));
        })
      },

      getDetailHoursMonths() {
        var arrHours = []
        arrHours["no_facturables"] = 0
        arrHours["sin_facturar"] = 0
        arrHours["por_facturar"] = 0
        arrHours["facturadas"] = 0

        var date_selected = null
        if(moment.isMoment(this.dateSelected)) {
          date_selected = this.dateSelected
        } else {
          date_selected = moment(this.dateSelected)
        }

        if(this.arr.detailsHours) {
          this.arr.detailsHours.forEach(element => {
            if(moment(element.date).format('Y-M') == date_selected.format('Y-M')) {
              if(element.not_invoice) {
                arrHours["no_facturables"] += parseFloat(element.hours)
              }

              if(!element.check_for_invoice && !element.not_invoice) {
                arrHours["sin_facturar"] += parseFloat(element.hours)
              }

              if(element.check_for_invoice && !element.not_invoice && !element.sale_id) {
                arrHours["por_facturar"] += parseFloat(element.hours)
              }

              if(element.sale_id) {
                arrHours["facturadas"] += parseFloat(element.hours)
              }
            }
          });
        }

        return arrHours
      },

      goProjects() {
        if(this.routerFrom == 'SalesStaffSalesGenerateByProjects') {
          this.$router.push({ name: 'ProjectStaffCrudProject' })
        } else {
          this.$router.go(-1)
        }
      },
    }
  }
</script>
<style>
  .detail-hours-task-source {
    align-items: center;
    color: var(--app-color-primary);
    display: flex;
    font-size: var(--app-text-xs);
    gap: 3px;
    margin-top: 3px;
  }
  .detail-hours-totals {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    border: 1px solid var(--app-color-border);
    border-radius: 8px;
    background: var(--app-color-surface-subtle);
    padding: 10px 12px;
  }
  .detail-hours-totals__label {
    color: var(--app-color-text-secondary);
  }
  .detail-hours-totals__value {
    font-weight: var(--app-font-semibold, 600);
    white-space: nowrap;
  }
  .detail-hours-status-legend {
    align-items: center;
    color: var(--app-color-text-muted);
    display: flex;
    flex-wrap: wrap;
    font-size: var(--app-text-xs);
    gap: 10px;
    margin-top: 10px;
  }
  .detail-hours-status-legend--table {
    justify-content: flex-end;
    margin: 0 0 8px;
  }
  .detail-hours-status-legend__item {
    align-items: center;
    display: inline-flex;
    gap: 4px;
  }
  .detail-hours-status-legend__dot {
    border-radius: 999px;
    display: inline-block;
    height: 9px;
    width: 9px;
  }
  .detail-hours-status-legend__dot--not-invoice { background-color: var(--app-color-text); }
  .detail-hours-status-legend__dot--unbilled { background-color: var(--app-color-danger-hover); }
  .detail-hours-status-legend__dot--to-invoice { background-color: var(--app-color-warning-hover); }
  .detail-hours-status-legend__dot--invoiced { background-color: var(--app-color-success-hover); }

  .detail-hours-calendar .fc-day,
  .detail-hours-calendar .fc-event {
    cursor: pointer !important;
  }

  .detail-hours-dropdown-icon {
    margin-right: 0.35rem;
    vertical-align: -0.15em;
  }
  .detail-hours-dropdown-icon--not-invoice { color: var(--app-color-text); }
  .detail-hours-dropdown-icon--unbilled { color: var(--app-color-danger); }
  .detail-hours-dropdown-icon--to-invoice { color: var(--app-color-warning); }

  /* Evita que el zebra-striping de .app-table--compact reemplace el estado
     de negocio de las horas en las filas pares. */
  .detail-hours-table tbody tr.detail-hours-row--not-invoice > td {
    background-color: #cbd8e6 !important;
    box-shadow: inset 0 0 0 9999px #cbd8e6 !important;
    color: var(--app-color-text) !important;
  }
  .detail-hours-table tbody tr.detail-hours-row--unbilled > td {
    background-color: #f9e1e5 !important;
    box-shadow: inset 0 0 0 9999px #f9e1e5 !important;
    color: var(--app-color-text) !important;
  }
  .detail-hours-table tbody tr.detail-hours-row--to-invoice > td {
    background-color: #fff0d6 !important;
    box-shadow: inset 0 0 0 9999px #fff0d6 !important;
    color: var(--app-color-text) !important;
  }
  .detail-hours-table tbody tr.detail-hours-row--invoiced > td {
    background-color: #ccefdc !important;
    box-shadow: inset 0 0 0 9999px #ccefdc !important;
    color: var(--app-color-text) !important;
  }
  .detail-hours-table tbody tr[class*="detail-hours-row--"] > td {
    padding-left: 12px !important;
  }
  @media (min-width: 768px) {
    .detail-hours-table tbody tr[class*="detail-hours-row--"] > td {
      height: 35px;
    }
  }
  /* Solo el contenido informativo directo hereda el color del estado. El
     menú del kebab también vive dentro del td, pero conserva sus propios
     colores para no quedar teñido por la fila. */
  .detail-hours-table tbody tr.detail-hours-row--not-invoice > td > b,
  .detail-hours-table tbody tr.detail-hours-row--not-invoice > td > div:not(.dropdown),
  .detail-hours-table tbody tr.detail-hours-row--unbilled > td > b,
  .detail-hours-table tbody tr.detail-hours-row--unbilled > td > div:not(.dropdown),
  .detail-hours-table tbody tr.detail-hours-row--to-invoice > td > b,
  .detail-hours-table tbody tr.detail-hours-row--to-invoice > td > div:not(.dropdown),
  .detail-hours-table tbody tr.detail-hours-row--invoiced > td > b,
  .detail-hours-table tbody tr.detail-hours-row--invoiced > td > div:not(.dropdown) {
    color: inherit !important;
  }
  .detail-hours-table tbody tr.detail-hours-row--not-invoice > td:first-child { box-shadow: inset 4px 0 0 var(--app-color-text), inset 0 0 0 9999px #cbd8e6 !important; }
  .detail-hours-table tbody tr.detail-hours-row--unbilled > td:first-child { box-shadow: inset 4px 0 0 var(--app-color-danger), inset 0 0 0 9999px #f9e1e5 !important; }
  .detail-hours-table tbody tr.detail-hours-row--to-invoice > td:first-child { box-shadow: inset 4px 0 0 var(--app-color-warning), inset 0 0 0 9999px #fff0d6 !important; }
  .detail-hours-table tbody tr.detail-hours-row--invoiced > td:first-child { box-shadow: inset 4px 0 0 var(--app-color-success), inset 0 0 0 9999px #ccefdc !important; }
  .detail-hours-table tbody tr.detail-hours-row--active > td {
    border-top: 1px solid var(--app-color-primary) !important;
    border-bottom: 1px solid var(--app-color-primary) !important;
  }
  .detail-hours-table tbody tr.detail-hours-row--active > td:first-child {
    border-left: 1px solid var(--app-color-primary) !important;
    box-shadow: inset 4px 0 0 var(--app-color-primary) !important;
  }
  .detail-hours-table tbody tr.detail-hours-row--active > td:last-child {
    border-right: 1px solid var(--app-color-primary) !important;
  }

  /* Excepción al kebab mudo de .app-table: esta tabla no tiene drawer que
     aloje las acciones, así que se conserva también en mobile — como link
     de texto alineado a la izquierda, no como botón con caja. */
  .btn.detail-hours-action-toggle-labeled {
    display: inline-flex !important;
    align-items: center;
    justify-content: flex-start;
    width: auto !important;
    height: auto !important;
    min-height: 0;
    padding: 0 !important;
    border: none !important;
    background: transparent !important;
    box-shadow: none !important;
    color: var(--app-color-text-secondary) !important;
    font-size: 13px;
    line-height: 1.15;
  }
  .btn.detail-hours-action-toggle-labeled:hover,
  .btn.detail-hours-action-toggle-labeled:focus {
    color: var(--app-color-primary) !important;
    text-decoration: underline;
  }
  /* Pisa la regla global que oculta el label del último field y lo alinea
     a la derecha (pensada para el kebab ícono-only sin texto). */
  @media (max-width: 767.98px) {
    .detail-hours-status-legend--table {
      display: none;
    }
    .detail-hours-table.app-table.b-table-stacked-md > tbody > tr > td:last-child::before {
      content: attr(data-label) !important;
    }
    .detail-hours-table.app-table.b-table-stacked-md > tbody > tr > td:last-child {
      text-align: left !important;
    }
  }

  /* Card "Horas pendientes de facturación": info + nota + total, con más
     jerarquía que un flat b-alert genérico. */
  .pending-invoice-info,
  .pending-invoice-note {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    border-radius: 8px;
    padding: 10px 12px;
  }
  .pending-invoice-info {
    background: var(--app-color-info-soft);
    border: 1px solid var(--app-color-info-border);
    color: var(--app-color-text);
    margin-bottom: 10px;
  }
  .pending-invoice-info__icon {
    color: var(--app-color-primary);
    flex-shrink: 0;
    margin-top: 2px;
  }
  .pending-invoice-note {
    background: var(--app-color-surface-subtle);
    border: 1px solid var(--app-color-border);
    color: var(--app-color-text-secondary);
    font-style: italic;
    margin-bottom: 14px;
  }
  .pending-invoice-note__icon {
    color: var(--app-color-text-muted);
    flex-shrink: 0;
    margin-top: 2px;
  }
  .pending-invoice-stat {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 12px;
    border: 1px solid var(--app-color-border);
    border-radius: 8px;
    background: var(--app-color-surface-subtle);
    padding: 12px 14px;
  }
  .pending-invoice-stat__label {
    display: block;
    font-size: var(--app-text-xs, 11px);
    text-transform: uppercase;
    letter-spacing: 0.04em;
    color: var(--app-color-text-secondary);
  }
  .pending-invoice-stat__value {
    display: block;
    font-size: 22px;
    font-weight: var(--app-font-semibold, 700);
    color: var(--app-color-text);
  }
  .pending-invoice-stat__actions {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
  }
  @media (max-width: 767.98px) {
    .pending-invoice-stat {
      flex-direction: column;
      align-items: stretch;
    }
    .pending-invoice-stat__actions {
      flex-direction: column;
    }
    .pending-invoice-stat__actions .btn {
      width: 100%;
    }
  }
</style>
